<app-close-authentication-tab-popin
  (continueEvent)="closeTab()"
  (cancelEvent)="closePopin()"
  [show]="showPopin"
></app-close-authentication-tab-popin>

<div class="flex flex-col pt-6 h-svh">
  <div class="self-end">
    <img
      (click)="askToCloseTab()"
      class="mr-2 cursor-pointer"
      src="../../../../../assets/images/svg/cross-close.svg"
    />
  </div>
  <div class="flex-1 text-center content-center">
    <img class="m-auto" src="../../../../../assets/svg/loader.svg" alt="loader" />
    <p class="mt-5">{{ 'bank_authentication_portail_is_loading' | translate }}</p>
  </div>
</div>
